<script lang="ts">
  import { query } from "svelte-apollo";
  import { GET_ACTIVE_MESSAGES } from "@modern/queries/messages/activeMessages";
  import type { Distributor } from "@shared/types/Distributor";
  import type { OneWayMessage } from "@shared/types/OneWayMessage";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import MessageAnnouncement from "./MessageAnnouncement.svelte";

  export let distributor: Distributor;
  export let authStatus: string;

  $: hasOneWayMessagesRollout = stagedRolloutCheck("marketplace__ohlq_one_way_messages");

  type OHLQMessagesQueryResult = {
    getActiveOHLQMessages: OneWayMessage[];
  };

  const messages =
    authStatus == "valid" ? query<OHLQMessagesQueryResult>(GET_ACTIVE_MESSAGES) : null;

  $: latestMessages =
    !$messages || $messages?.loading || $messages?.error
      ? []
      : $messages.data?.getActiveOHLQMessages;
  $: showOneWayMessages = latestMessages && hasOneWayMessagesRollout;
</script>

{#if showOneWayMessages}
  <div class="craft mt-16">
    {#each latestMessages as message}
      <MessageAnnouncement {message} {distributor} />
    {/each}
  </div>
{/if}
